import { defineStore } from 'pinia';
import { useApiStore } from './API.module';
import dayjs from 'dayjs';

export const usePaymentsStore = defineStore('payments', {
  state: () => ({
    api: null,
    items: [],
    paymentPage: 0,
    rowsOnLastPage: 0,
    paymentAggr: { maxId: null, count: '0', summa: '0', comission: '0' },
    paymentStatus: null,
    dealer: null,
    supplier: null,
    service: null,
    terminal: null,
    paymentFilter: {
      guid: '',
      id: '',
      requisite: '',
      billnum: '',
      startDate: dayjs().format('YYYY-MM-DD 00:00:00'),
      endDate: dayjs().format('YYYY-MM-DD 23:59:59'),
      status: null,
      TimeType: '0',
      rows: 50,
      dbName: 'prodDB',
      sortBy: 'date',
      sortOrder: 'desc'
    }
  }),
  getters: {
    count: (state) => state.paymentAggr.count || 0,
    summa: (state) => state.paymentAggr.summa || 0,
    comission: (state) => state.paymentAggr.comission || 0,
    rowCount: (state) => state.rowsOnLastPage || 0
  },
  actions: {
    async getList(data) {
      this.api = 'getList';
      try {
        data.page = this.paymentPage;
        data.maxId = this.paymentAggr.maxId;
        const response = await useApiStore().send({ method: 'post', requestURL: '/payments', requestData: data });
        if (!Array.isArray(response)) return;
        if (this.paymentPage === 0) {
          this.paymentAggr = response.shift();
        }
        this.paymentPage++;
        this.rowsOnLastPage = response.length;
        this.items = (this.items ?? []).concat(response);
        this.api = 'success';
      } catch {
        this.api = null;
      }
    },
    async fetchStatus(data) {
      this.api = 'status';
      try {
        const response = await useApiStore().send({ method: 'get', requestURL: '/payments/status/' + data.guid });
        this.paymentStatus = response.PaymentStatus[0];
        this.api = 'success';
      } catch {
        this.api = null;
      }
    },
    async cancel(data) {
      this.api = 'cancel';
      try {
        await useApiStore().send({ method: 'put', requestURL: '/payments/cancel', requestData: data });
        this.api = 'success';
      } catch {
        this.api = null;
      }
    },
    async downloadXlsx(data) {
      const response = await useApiStore().send({
        method: 'post',
        requestURL: '/payments/xlsx',
        requestData: data,
        responseType: 'blob',
      });
      const url = URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      const ext = response.data.type === 'application/zip' ? 'zip' : 'xlsx';
      a.download = response.headers['content-disposition']?.match(/filename="(.+)"/)?.[1] || `payments.${ext}`;
      a.click();
      URL.revokeObjectURL(url);
    },
    async getById(id, dbName) {
      return useApiStore().send({
        method: 'get',
        requestURL: `/payments/${id}?dbName=${dbName || 'prodDB'}`,
      });
    },
    initCounters() {
      this.paymentPage = 0;
      this.rowsOnLastPage = 0;
      this.paymentAggr = { maxId: null, count: '0', summa: '0', comission: '0' };
      this.items = [];
    }
  }
});
